import React, { Component } from 'react';
import { connect } from 'react-redux';

import api from 'core/utils/api';
import Spin from 'components/ui/Spin';
import DuplicateTestForm from './DuplicateTestForm';
import { success as notifySuccess } from 'components/ui/Notify/store/actions';

class DuplicateTestEditContainer extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;
    this.state = {
      loading: true,
      id,
    };
  }

  componentDidMount() {
    api
      .get(`/duplicate_tests/${this.state.id}`)
      .then((res) => {
        this.setState({
          loading: false,
          duplicateTest: res.data.duplicate_test,
        });
      });
  }

  handleSubmit = (values, setSubmitting) => {
    const { dispatch, history } = this.props;

    api
      .patch(`/duplicate_tests/${this.state.id}`, { duplicate_test: values })
      .then(() => {
        setSubmitting(false);
        dispatch(notifySuccess('Duplicate test successfully updated.'));
        history.push('/qa/crm/duplicates');
      });
  }

  render() {
    const { loading, duplicateTest } = this.state;

    if (loading) {
      return <Spin />;
    }

    return (
      <DuplicateTestForm
        initialValues={duplicateTest}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default connect()(DuplicateTestEditContainer);



// WEBPACK FOOTER //
// ./src/features/qa/DuplicateTestEditContainer.js